const ACCESS_TOKEN_KEY = 'scaler_access_token'
const REMEMBER_ME_KEY = 'scaler_remember_me'

export function getAccessToken(): string | null {
    // Check sessionStorage as a migration fallback for tokens stored before this change
    const sessionToken = sessionStorage.getItem(ACCESS_TOKEN_KEY)
    if (sessionToken) {
        localStorage.setItem(ACCESS_TOKEN_KEY, sessionToken)
        sessionStorage.removeItem(ACCESS_TOKEN_KEY)
    }

    return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export function setAccessToken(token: string): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export function clearAccessToken(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    sessionStorage.removeItem(ACCESS_TOKEN_KEY)
}

export function setRememberPreference(remember: boolean): void {
    if (remember) {
        sessionStorage.setItem(REMEMBER_ME_KEY, '1')
        return
    }
    sessionStorage.removeItem(REMEMBER_ME_KEY)
}

export function consumeRememberPreference(): boolean {
    const value = sessionStorage.getItem(REMEMBER_ME_KEY) === '1'
    sessionStorage.removeItem(REMEMBER_ME_KEY)

    return value
}
